module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirmLicense"
  }, [_c('h1', [_vm._v("Confirm License")]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('h2', [_vm._v("Modify License Form")]), _vm._v(" "), _c('el-form', {
    ref: "newLicenseForm",
    attrs: {
      "label-position": "left",
      "model": _vm.newLicenseForm,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Expiry Date [as UTC(+00:00)]"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "Select Date",
      "default-value": new Date(),
      "value-format": "yyyy-MM-ddTHH:mm:ss.000Z"
    },
    on: {
      "change": _vm.OnExpiryDateChange
    },
    model: {
      value: (_vm.tmp_exp_date),
      callback: function($$v) {
        _vm.tmp_exp_date = $$v
      },
      expression: "tmp_exp_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "plain": "",
      "loading": _vm.modifying
    },
    on: {
      "click": _vm.modifyLicense
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021c5a0a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmLicense.vue
// module id = b3v3
// module chunks = 1